import { forwardRef, type ComponentPropsWithoutRef } from 'react';

export const MinusIcon = forwardRef<
  SVGSVGElement,
  ComponentPropsWithoutRef<'svg'>
>((props, ref) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 24 24"
    ref={ref}
    fill="none"
    stroke="currentColor"
    strokeWidth={2}
    className="h-6 w-6"
    {...props}
  >
    <path strokeLinecap="round" strokeLinejoin="round" d="M20 12H4" />
  </svg>
));

MinusIcon.displayName = 'MinusIcon';
